export default __webpack_public_path__ + "static/media/sold_single.7a5cef06.svg";